import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/en';
import zhCN from './locales/zh-CN';

Vue.use(VueI18n);

export const supportedLocales = ['en', 'zh-CN'];
export const defaultLocale = 'en';

function normalizeLocale(locale) {
  return supportedLocales.includes(locale) ? locale : defaultLocale;
}

export function getStoredLocale() {
  if (typeof window === 'undefined') return defaultLocale;
  return normalizeLocale(window.localStorage.getItem('sparrow-locale'));
}

const i18n = new VueI18n({
  locale: getStoredLocale(),
  fallbackLocale: defaultLocale,
  silentFallbackWarn: true,
  messages: {
    en,
    'zh-CN': zhCN
  }
});

export function setLocale(locale) {
  const nextLocale = normalizeLocale(locale);
  i18n.locale = nextLocale;

  if (typeof window !== 'undefined') {
    window.localStorage.setItem('sparrow-locale', nextLocale);
  }

  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', nextLocale);
  }

  return nextLocale;
}

setLocale(i18n.locale);

export default i18n;
